import { createPortal } from 'react-dom';

import $ from './modal.scss';
import cx from '~source/utils/join-class-names';

export function Modal({
    children,
    programModal,
}: {
    children: React.ReactNode;
    programModal?: boolean;
}) {
    return createPortal(
        <div
            className={$.modalBackground}
            role='presentation'
            onClick={(e) => {
                // Stop propagation to prevent clicks from reaching underlying elements
                e.stopPropagation();
            }}
        >
            <div
                className={cx($.modal, programModal && $.programModal)}
                role='presentation'
                onClick={(e) => {
                    // Stop propagation to prevent clicks from reaching the background handler
                    e.stopPropagation();
                }}
            >
                {children}
            </div>
        </div>,
        document.body,
    );
}
